import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_CONDITION_OF_ASSET_SUCCESS,
  FETCH_CONDITION_OF_ASSET_SUCCESS,
  GET_CONDITION_OF_ASSET_SUCCESS,
  SAVE_CONDITION_OF_ASSET_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {
  fetchError,
  fetchFilter,
  fetchStart,
  fetchSubElementFilter,
  fetchSuccess,
  fetchSuperMasterFilter
} from "./Common";
import {getUser} from "./Auth";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_CONDITION_OF_ASSET_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_CONDITION_OF_ASSET_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_CONDITION_OF_ASSET_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_CONDITION_OF_ASSET_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {conditionOfAsset} = store.getState();
      const {query} = conditionOfAsset;
      const response = await axios.get(`/condition-of-asset?${generateQueryString(query)}`);

      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {conditionOfAsset} = store.getState();
      const {query} = conditionOfAsset;
      const response = await axios.get(`/condition-of-asset/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload, redirect= true, module, subMaster= false, superMaster=false) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/condition-of-asset`, payload);
      if(response && response.data && response.data.code === 202){
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({data: response.data}));
      }

      if (!redirect) {
        if(subMaster) {
          dispatch(fetchSubElementFilter(module));
        } else {
          if (superMaster) {
            dispatch(fetchSuperMasterFilter(module));
          } else {
            dispatch(fetchFilter(module));
          }
        }
      } else {
        history.push('/condition-of-asset');
        dispatch(getResource());
      }
    } catch (error) {
      const errorMessage = error.response && error.response.data && error.response.data.message
      if (errorMessage) message.error(errorMessage);
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response=await axios.put(`/condition-of-asset/${id}`, payload);
      if (response && response.data && response.data.code === 202){
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/condition-of-asset');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/condition-of-asset/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/condition-of-asset/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
